import { Asset } from '@/types/asset_search';
import { SearchInputDto } from '@/types/types';
import { setupAssetDerivedFields } from '@/utils';
import { apiBase } from './apiBase';

const EXCEPTION_HISTORY_TAG = 'EXCEPTION_HISTORY';

export const searchApi = apiBase
  .enhanceEndpoints({
    // Used for caching and invalidating data
    addTagTypes: [EXCEPTION_HISTORY_TAG],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getVinSearch: builder.query<Asset[], SearchInputDto>({
        query: ({ siteId, params }) => {
          let tokens = params.split(/[\s,\t]+/);
          tokens = tokens.filter((token) => token.trim() !== '');
          const encodedTokens = tokens.map((token) =>
            encodeURIComponent(token),
          );
          const encodedParams = encodedTokens.join(',');

          return {
            url: `external/search?siteId=${siteId}&params=${encodedParams}`,
          };
        },
        transformResponse: (response: Asset[]) => {
          if (!response || !Array.isArray(response) || response.length === 0) {
            return [];
          }
          const mappedResponse = setupAssetDerivedFields(response);
          return mappedResponse;
        },
        keepUnusedDataFor: 0.0001,
      }),
    }),
    overrideExisting: false,
  });

export const { useGetVinSearchQuery } = searchApi;
